export function getNoneStringItem<T>(key: string): T | null {
  const storedValue = localStorage.getItem(key);
  if (storedValue === null) {
    return null;
  }

  try {
    return JSON.parse(storedValue) as T;
  } catch (_) {
    return null;
  }
}

export function setNoneStringItem(key: string, value: any) {
  localStorage.setItem(key, JSON.stringify(value));
}
